import axios from "axios";
import { companyInfo0, generalSetting0 } from "@/data/PosSettingsSignal.ts";
import { computed, effectOn, signal } from "@/react/core/reactive.ts";
import { DeliverySetting } from "@/data/DeliverySetting.ts";
import { toast } from "react-toastify";
import _ from "lodash";
import { mapScriptLock } from "@/react/core/GoogleMapsProvider.tsx";
import { getApiUrl } from "@/shared/utils.ts";
import { deliverySettings0 } from "@/data/DeliverySettingsHub.ts";

let firstCall = true
let isPolygonAvailable = false
const apiKeyGeoapify = "c1bec41c71b740c59af19369645e3d55";
export const defaultZoom = 13
export const defaultLocation = { latitude: 37.7749, longitude: -122.4194 }
export type Coordinates = { latitude: number; longitude: number };
export type Polygon = {
  path: any[],
  options: {
    fillColor: string,
    fillOpacity: number,
    strokeColor: string,
    strokeOpacity: number,
    strokeWeight: number,
  },
  zoneRef?: string,
  postalCode?: string,
}
export const mapContainerStyle = {
  width: '100%',
  height: '100%',
}
export const [polygonInfo, setPolygonInfo] = signal<DeliverySetting>()
export const [polygons, setPolygons] = signal<Polygon[]>([]);
export const [mapInstance, setMapInstance] = signal<google.maps.Map | null>(null);
export const [myLocation, setMyLocation] = signal<Coordinates>();
export const [isCheckingAddress, setIsCheckingAddress] = signal(false);
export const deliverySettingsZone = computed(() => {
  return deliverySettings0()?.filter(d => d.type === 'zone') || []
})
export const deliverySettingsRadius = computed(() => {
  return deliverySettings0()?.filter(d => d.type === 'radius') || []
})
export const DELIVERY_ZONE_COLORS = [
  "#007c7c", "#cf24e5", "#e76100", "#00a21b", "#313131",
  "#977b08", "#4175fb", "#0bc41b", "#274774", "#0087d0",
  "#8f181d", "#ff5733", "#33ff57", "#5733ff", "#ff33a8",
  "#33a8ff"
];
export const updateColorPolygon = (zone: DeliverySetting) => {
  setPolygons((prevPolygons) => {
    return prevPolygons.map((p) => {
      if (p.postalCode === zone.postalCode) {
        const updatedPolygon = {
          ...p,
          options: { ...p.options, fillColor: zone.color! }
        };
        localStorage.setItem(`polygon-${p.postalCode}`, JSON.stringify(updatedPolygon));
        return updatedPolygon;
      }
      return p;
    });
  });
};

function isPointInPolygon(lat: number, lng: number, polygon: Polygon): boolean {
  let x = lat, y = lng;
  let inside = false;
  const path = polygon.path;

  for (let i = 0, j = path.length - 1; i < path.length; j = i++) {
    let xi = path[i].lat, yi = path[i].lng;
    let xj = path[j].lat, yj = path[j].lng;

    let intersect = yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;
    if (intersect) inside = !inside;
  }

  return inside;
}

export async function findSettingFromAddress(address: string, placeId?: string): Promise<DeliverySetting | null> {
  if (!generalSetting0()?.enableDeliverySetting) return null
  if (!polygons()?.length) {
    await drawPolygonForAllZone()
  }
  setIsCheckingAddress(true)
  console.log('[findSettingFromAddress]', address, placeId)
  try {
    // const params: Record<string, string> = {
    //   countryAlpha2Code: companyInfo0()?.country?.toUpperCase() || '',
    //   searchPlace: companyInfo0()?.address || ''
    // };
    // const { data: coord } = await axios.get(getApiUrl() + "/api/map/coords", { params });
    const url = `https://api.geoapify.com/v1/geocode/search?text=${encodeURIComponent(address)}&lang=${getLang()}&apiKey=${apiKeyGeoapify}`
    const { data } = await axios.get(url);
    const coord = placeId ? data.features?.[0]?.geometry?.coordinates : data.features?.[0]?.geometry?.coordinates;
    if (!coord || coord.length < 2) return null;
    const [lng, lat] = coord;
    console.log({ lat, lng }, polygons())
    for (const polygon of polygons()) {
      if (isPointInPolygon(lat, lng, polygon)) {
        console.log('use polygon for calculate shipping fee')
        return deliverySettingsZone()?.find(d => d._id === polygon.zoneRef) || null
      }
    }
    console.log('use radius for calculate shipping fee')
    console.log("[findPolygonContainingPoint] coord", coord);
    if (coord.latitude) {
      await getMyLocation()
      const distance = getDistance(lat, lng, myLocation().latitude, myLocation().longitude)
      console.log("[findPolygonContainingPoint] distance", distance)
      return findDeliverySettingByDistance(distance, deliverySettingsRadius())
    }
    return null
  } catch (error) {
    console.error('err when findPolygonContainingPoint', error);
    return null
  } finally {
    setIsCheckingAddress(false)
  }
}

export function getLang() {
  const country = companyInfo0()?.country!;
  const map: Record<string, string> = {
    vn: 'vi',
    de: 'de',
    fr: 'fr',
    cn: 'zh',
    en: 'en',
    us: 'vn',
  };
  return map[country] || 'en';
}

export async function getMyLocation() {
  if (!myLocation()?.latitude) {
    const countryAlpha2Code = companyInfo0()?.country?.toUpperCase()
    const { data: coord } = await axios.get(getApiUrl() + "/api/map/coords", {
      params: { countryAlpha2Code, code: companyInfo0()?.zipCode, searchPlace: companyInfo0()?.address }
    });
    console.log(countryAlpha2Code, `getMyLocation location for ${companyInfo0()?.address} is:`, coord);
    setMyLocation(coord);
  }
}

window.findSettingFromAddress = findSettingFromAddress

export const autoGenDeliveryFee = async (address: string) => {
  if (!address) {
    toast.warning(`Missing customer address! `)
    return
  }
  const setting = await findSettingFromAddress(address)
  return setting?.cost || null
}

function findDeliverySettingByDistance(
  distance: number,
  deliverySettings: DeliverySetting[]
): DeliverySetting | null {
  const filtered = deliverySettings
    .filter(d => d.type === 'radius' && d.distance !== undefined && d.distance >= distance)
    .sort((a, b) => (a.distance ?? Infinity) - (b.distance ?? Infinity)); // Lấy vùng gần nhất
  return filtered.length > 0 ? filtered[0] : null;
}

function getDistance(lat1: number, lng1: number, lat2: number, lng2: number) {
  const R = 6371000;
  const toRad = (x: number) => (x * Math.PI) / 180;

  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
    Math.sin(dLng / 2) * Math.sin(dLng / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return R * c;
}

//@ts-ignore
window.drawPolygonForAllZone = drawPolygonForAllZone

export const getInfoPolygon = (p: any, location: { lat: number, lng: number }) => {
  const setting = deliverySettingsZone()?.find(d => d._id === p?.zoneRef)
  if (setting) {
    setPolygonInfo({ ...setting, location })
  }
}

const getNextColor = () => {
  return DELIVERY_ZONE_COLORS[Math.floor(Math.random() * DELIVERY_ZONE_COLORS.length)];
};

export const drawPolygon = async (zone: DeliverySetting, mapInstance?: any) => {
  try {
    const postalCode = zone.postalCode!

    const cachePolygon = localStorage.getItem(`polygon-${postalCode}`)
    if (!!cachePolygon) {
      console.log('[drawPolygon] use cache polygon for ', postalCode)
      const newPolygon = JSON.parse(cachePolygon)
      addNewPolygon(newPolygon)
      const path = newPolygon.path
      const centerIndex = Math.floor(path.length / 2);
      if (mapInstance) mapInstance!.panTo(path[centerIndex]);
      return
    }

    const boundary = await getBoundaryByPostalCode(postalCode);
    console.log("[drawPolygon] boundary: ", boundary);
    if (!boundary) {
      return;
    }
    let path = [];
    if (boundary.type === "Polygon") {
      path = boundary.coordinates[0].map(([lng, lat]: [number, number]) => ({
        lat,
        lng,
      }));
    } else if (boundary.type === "MultiPolygon") {
      path = boundary.coordinates[0][0].map(([lng, lat]: [number, number]) => ({
        lat,
        lng,
      }));
    } else {
      console.error("Dữ liệu biên giới không hợp lệ.");
      return;
    }
    const newPolygon = {
      path,
      options: {
        fillColor: zone.color || getNextColor(),
        fillOpacity: 0.7,
        strokeColor: "#000000",
        strokeOpacity: 1,
        strokeWeight: 2,
      },
      zoneRef: zone._id,
      postalCode: postalCode,
    };
    addNewPolygon(newPolygon)
    if (newPolygon.postalCode) {
      console.log(`save polygon-${newPolygon.postalCode}`)
      localStorage.setItem(`polygon-${newPolygon.postalCode}`, JSON.stringify(newPolygon))
    }
    const centerIndex = Math.floor(path.length / 2);
    if (mapInstance) mapInstance!.panTo(path[centerIndex]);
  } catch (error) {
    console.error("Lỗi khi vẽ polygon:", error);
  }
}

function addNewPolygon(newPolygon: Polygon) {
  setPolygons((prevPolygons) => {
    const existingIndex = prevPolygons.findIndex(p => p.zoneRef === newPolygon.zoneRef);
    if (existingIndex !== -1) {
      const updatedPolygons = [...prevPolygons];
      updatedPolygons[existingIndex] = newPolygon;
      return updatedPolygons;
    } else {
      return [...prevPolygons, newPolygon];
    }
  });
}

//@ts-ignore
window.polygons = polygons

export function getFillColorPolygon(settingId: string, polygonColor?: string) {
  return deliverySettingsZone().find(d => d._id === settingId)?.color || polygonColor || "#e76100";
}

export const debounceDrawPolygon = _.debounce(async (zone: DeliverySetting, code: string) => {
  if (code.length < 5) return
  console.log('[debounceDrawPolygon] call')
  await drawPolygon(zone, mapInstance());
}, 1000);

export async function drawPolygonForAllZone() {
  const zones = deliverySettingsZone()
  console.log('drawPolygonForAllZone zones ', zones?.length)
  if (!zones?.length && firstCall) return
  firstCall = false
  console.log('[drawPolygonForAllZone] call')
  for (const zone of zones) {
    if (!zone.postalCode || zone.postalCode.length < 5 || !zone.isEnable) continue
    const polygon = polygons().find(p => p.zoneRef === zone._id)
    if (!polygon) {
      drawPolygon(zone).then()
    }
  }
}

effectOn([deliverySettingsZone], async () => {
  if (!generalSetting0()?.enableDeliverySetting) return
  if (!isPolygonAvailable && deliverySettingsZone()?.length > 0) {
    await drawPolygonForAllZone()
    isPolygonAvailable = true
  }
}, { defer: true })

export const getBoundaryByPostalCode = async (postalCode: string) => {
  try {
    const geocode = await getGeocodePostalCode(postalCode);
    if (!geocode) {
      console.log("!geocode, return")
      return
    }
    const lat = geocode.lat()
    const lng = geocode.lng()
    console.log({ lat, lng })
    const geometryResponse = await axios.get(`https://api.geoapify.com/v1/boundaries/part-of?lat=${lat}&lon=${lng}&geometry=geometry_10000&apiKey=${apiKeyGeoapify}`);
    return geometryResponse.data?.features[0]?.geometry
  } catch (error: any) {
    console.error("Lỗi:", error.message);
    return null;
  }
};

export const getGeocodePostalCode = async (postalCode: string): Promise<{
  lat: () => number,
  lng: () => number
} | null> => {
  try {
    if (!window.google?.maps) {
      const { data: coord } = await axios.get(getApiUrl() + "/api/map/coords", {
        params: {
          countryAlpha2Code: companyInfo0()?.country?.toUpperCase(),
          code: postalCode,
          searchPlace: postalCode
        }
      });
      console.log('getGeocodePostalCode [/api/map/coords] rs ', coord)
      return { lat: () => coord.lattitude, lng: () => coord.longitude }
    } else {
      const geocoder = new window.google.maps.Geocoder();
      const { results } = await geocoder.geocode({
        address: postalCode,
        componentRestrictions: {
          country: companyInfo0()?.country?.toUpperCase()!,
        },
      });
      console.log('[getGeocodePostalCode] results:', results);
      return results[0].geometry.location || null
    }
  } catch (e: any) {
    console.error('[getGeocodePostalCode] err: ', e)
    return null;
  }
};
//@ts-ignore
window.getGeocodePostalCode = getGeocodePostalCode

export const getCoordCustomer = async (customerRaw: any) => {
  await mapScriptLock.acquireAsync();
  try {
    if (!customerRaw.address && !customerRaw.placeId) {
      console.error('Không có đủ dữ liệu để lấy tọa độ');
      return null;
    }

    const geocoder = new window.google.maps.Geocoder();
    const request: any = {};
    if (customerRaw.address) {
      request.address = customerRaw.address;
    } else if (customerRaw.placeId) {
      request.placeId = customerRaw.placeId;
    }

    const geocodeResult = await new Promise((resolve, reject) => {
      geocoder.geocode(request, (results, status) => {
        if (status === 'OK') {
          resolve(results);
        } else {
          reject(`Geocoder failed due to: ${status}`);
        }
      });
    }) as any;

    console.log("[geocoder.geocode] geocodeResult is: ", geocodeResult);

    if (geocodeResult && geocodeResult[0]?.geometry?.location) {
      const location = geocodeResult[0].geometry.location;
      return { lat: location.lat(), lng: location.lng() };
    } else {
      console.error('Không tìm thấy tọa độ:', customerRaw);
      return null;
    }
  } catch (error) {
    console.error('Lỗi khi lấy tọa độ từ API:', error);
    return null;
  }
}

export const backToMyLocation = (myLocation: { latitude: number, longitude: number }) => {
  if (mapInstance() !== null && myLocation) {
    mapInstance()!.panTo({ lat: myLocation.latitude, lng: myLocation.longitude });
  }
}

export const zoomIn = () => {
  if (!mapInstance()) return;
  const zoom = mapInstance()!.getZoom();
  if (zoom !== undefined) {
    mapInstance()!.setZoom(zoom + 1);
  }
}

export const zoomOut = () => {
  if (!mapInstance()) return;
  const zoom = mapInstance()!.getZoom();
  if (zoom !== undefined) {
    mapInstance()!.setZoom(zoom - 1);
  }
}
